module.exports = __webpack_public_path__ + "media/images/no_content.icon.user-d77b6805.png";